<template>
    <div class="qr-wrapper" :key="uniq_ref">
        <div class="qr-box"></div>
        <div class="flex">
            <button class="btn btn-sm btn-primary mt-2" @click="downloadQr">{{ __t('DOWNLOAD') }}</button>
            <button class="btn btn-sm btn-primary mt-2" @click="go_url">{{ __t('GO_URL') }}</button>
        </div>
    </div>
</template>

<script>
import QrCodeStyling from 'qr-code-styling-ext';

export default {
    name: 'qr_code',

    props: {
        url: { type: String, required: true },
        color: { type: String, default: '#000000' },
        bgColor: { type: String, default: '#ffffff' },
        logo: { type: String, default: null },
        size: { type: Number, default: 600 },
        uniq_ref : { type: String, default: '' },
    },

    data() {
        return {
            qr: null
        };
    },

    mounted() {
        setTimeout(() => this.initQr(), 200);
       // this.$nextTick(() => this.initQr());
    },

    watch: {
        url: 'initQr',
        color: 'initQr',
        bgColor: 'initQr',
        logo: 'initQr',
        size: 'initQr'
    },

    methods: {

        go_url() {
            window.open(this.url,'_blank');
        },

        initQr() {
            this.$nextTick(() => {
                const el = this.$el.querySelector('.qr-box');
                if (!el) return;

                el.innerHTML = '';

                this.qr = new QrCodeStyling({
                    width: this.size,
                    height: this.size,
                    type: 'canvas',
                    data: this.url,
                    image: this.logo,
                    dotsOptions: {
                        color: this.color,
                        type: 'rounded'
                    },
                    backgroundOptions: {
                        color: this.bgColor
                    },
                    imageOptions: {
                        crossOrigin: 'anonymous',
                        margin: 5
                    }
                });

                this.qr.append(el);
            });
        },

        downloadQr() {
            if (!this.qr) return;

            const scale = 5; // качество
            const bigSize = this.size * scale;

            // скрытый контейнер, чтобы не влияло на UI
            const tmp = document.createElement('div');
            tmp.style.position = 'fixed';
            tmp.style.left = '-99999px';
            tmp.style.top = '0';
            tmp.style.width = bigSize + 'px';
            tmp.style.height = bigSize + 'px';
            tmp.style.overflow = 'hidden';
            document.body.appendChild(tmp);

            const qrTmp = new QrCodeStyling({
                width: bigSize,
                height: bigSize,
                type: 'canvas',
                data: this.url,
                image: this.logo,
                dotsOptions: { color: this.color, type: 'rounded' },
                backgroundOptions: { color: this.bgColor },
                imageOptions: { crossOrigin: 'anonymous', margin: 5 * scale } // можно и 5 оставить
            });

            qrTmp.append(tmp);

            // даём отрисоваться, потом скачиваем и чистим
            setTimeout(() => {
                qrTmp.download({ name: 'qr-code', extension: 'png' });

                // cleanup
                document.body.removeChild(tmp);
                // (объект qrTmp сам умрёт, но можно явно занулить)
                // qrTmp = null; // нельзя если const, но и не надо
            }, 80);
        }
    }
};
</script>

<style scoped>
.qr-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.qr-box {
    border: 1px solid #ccc;
    padding: 8px;
    border-radius: 10px;
    background: #f8f8f8;
    max-width: 300px;
    max-height: 300px;
}
</style>
